export function buildOssImageUrl(url) {
  return `${url}?x-oss-process=image/format,jpg/quality,q_80`
}
